
/* Bilmedie bulb finder v3 – Shopify / Cloudflare Worker v3 */
(() => {
  const initFinder = (root) => {
    if (root.dataset.initialized === '1') return;

    const endpoint = (root.dataset.endpoint || '').trim().replace(/\/$/, '');
    const brand = root.querySelector('[data-brand]');
    const model = root.querySelector('[data-model]');
    const year = root.querySelector('[data-year]');
    const submit = root.querySelector('[data-submit]');
    const form = root.querySelector('[data-finder-form]');
    const status = root.querySelector('[data-status]');
    const results = root.querySelector('[data-results]');

    if (![brand, model, year, submit, form, status, results].every(Boolean)) return;
    root.dataset.initialized = '1';

    const stylesId = 'bm-bulb-finder-dialog-styles';

    if (!document.getElementById(stylesId)) {
      const style = document.createElement('style');
      style.id = stylesId;
      style.textContent = `
        .bm-finder__modal,
        .bm-finder__result-modal {
          position: fixed;
          inset: 0;
          z-index: 2147483000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          background: rgba(12,30,45,.7);
        }
        .bm-finder__modal[hidden],
        .bm-finder__result-modal[hidden],
        .bm-finder__reopen[hidden],
        .bm-finder__compact-card[hidden],
        .bm-finder__upgrades[hidden] {
          display: none !important;
        }
        .bm-finder__modal-content {
          width: 100%;
          max-width: 440px;
          padding: 24px;
          border-radius: 14px;
          background: #fff;
          box-shadow: 0 15px 55px rgba(0,0,0,.22);
        }
        .bm-finder__modal-content h3 {
          margin: 0 0 17px;
          color: #172b39;
          font-size: 20px;
        }
        .bm-finder__modal-content select,
        .bm-finder__headlight-choice {
          display: block;
          width: 100%;
          min-height: 45px;
          padding: 10px 12px;
          border: 1px solid #d7e2eb;
          border-radius: 8px;
          background: #fff;
          color: #172b39;
          font-size: 14px;
        }
        .bm-finder__modal-confirm {
          display: block;
          width: 100%;
          min-height: 44px;
          margin-top: 15px;
          padding: 11px 16px;
          border: 0;
          border-radius: 8px;
          background: #145a91;
          color: #fff;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
        }
        .bm-finder__modal-confirm:disabled {
          background: #aabac7;
          cursor: not-allowed;
        }
        .bm-finder__modal-back {
          display: block;
          margin: 10px auto 0;
          padding: 8px;
          border: 0;
          background: transparent;
          color: #145a91;
          cursor: pointer;
          text-decoration: underline;
        }
        .bm-finder__result-modal {
          z-index: 2147482999;
        }
        .bm-finder__result-panel {
          width: min(920px,100%);
          max-height: calc(100vh - 48px);
          overflow: auto;
          overscroll-behavior: contain;
          background: #fff;
          border-radius: 14px;
          padding: 22px 26px;
          box-shadow: 0 20px 60px rgba(0,0,0,.24);
        }
        .bm-finder__result-toolbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding-bottom: 12px;
          border-bottom: 1px solid #e1e7eb;
          color: #172b39;
          font-size: 17px;
        }
        .bm-finder__result-close {
          border: 1px solid #d5e2eb;
          background: #f1f6fa;
          color: #174d76;
          border-radius: 8px;
          padding: 8px 13px;
          font-size: 13px;
          cursor: pointer;
        }
        .bm-finder__reopen {
          margin-top: 12px;
          border: 0;
          background: #145a91;
          color: #fff;
          padding: 11px 16px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 700;
        }
        .bm-finder__headlight-choice {
          margin-top: 12px;
          max-width: 360px;
        }
        .bm-finder__modal :focus-visible,
        .bm-finder__result-modal :focus-visible {
          outline: 2px solid #145a91;
          outline-offset: 3px;
        }
        @media (min-width:1024px) {
          .bm-finder__result-panel .bm-finder__compact-grid {
            grid-template-columns: repeat(3,minmax(0,1fr)) !important;
          }
          .bm-finder__result-panel .bm-finder__results {
            margin-top: 0;
            padding-top: 14px;
          }
        }
        @media (max-width:1023px) {
          .bm-finder__result-modal {
            display: none !important;
          }
        }
        @media (max-width:767px) {
          .bm-finder__modal-content {
            padding: 20px;
          }
        }
      `;
      document.head.append(style);
    }

    const el = (tag, className = '', text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    const message = value => {
      status.textContent = value;
    };

    const resetSelect = (select, placeholder) => {
      select.replaceChildren(new Option(placeholder, ''));
      select.disabled = true;
    };

    const populate = (select, entries, placeholder) => {
      resetSelect(select, placeholder);

      const options = entries.map(item => {
        const value = item && typeof item === 'object'
          ? String(item.value ?? '')
          : String(item);

        const label = item && typeof item === 'object'
          ? String(item.label ?? value)
          : value;

        return { value, label };
      });

      options.sort((a, b) =>
        a.label.localeCompare(b.label, 'da', {
          sensitivity: 'base',
          numeric: true
        })
      );

      for (const option of options) {
        if (option.value) {
          select.add(new Option(option.label, option.value));
        }
      }

      select.disabled = select.options.length < 2;
    };

    const load = async (path, params = {}) => {
      const url = new URL(endpoint + path);

      for (const [key, value] of Object.entries(params)) {
        url.searchParams.set(key, String(value));
      }

      const res = await fetch(url, {
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) {
        throw new Error('API HTTP ' + res.status);
      }

      return res.json();
    };

    const safeShopUrl = (
      value,
      fallback = '/collections/bilpaerer'
    ) => {
      const raw = String(value || '');

      return raw.startsWith('/') &&
        !raw.startsWith('//') &&
        !raw.includes('\\')
        ? raw
        : fallback;
    };

    const addNotice = (
      heading,
      body,
      className = 'bm-finder__warning'
    ) => {
      const panel = el('div', className);
      panel.append(
        el('strong', '', heading),
        el('p', '', body)
      );
      results.append(panel);
      return panel;
    };

    const addSupport = (data, reason = '') => {
      const panel = addNotice(
        'Har du brug for hjælp til at finde den rigtige pære?',
        reason ||
          data.support_message ||
          'Kontakt vores kundeservice for hjælp til at vælge korrekt pære.',
        'bm-finder__warning bm-finder__support'
      );

      const link = el(
        'a',
        'bm-finder__support-link',
        'Kontakt kundeservice'
      );

      link.href = safeShopUrl(
        data.support_url,
        '/pages/kontakt'
      );

      panel.append(link);
    };

    // Modelgenerations-popup

    const modal = el('div', 'bm-finder__modal');
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    const modalPanel = el(
      'div',
      'bm-finder__modal-content'
    );

    const modalHeading = el(
      'h3',
      '',
      'Vælg modelgeneration'
    );

    modalHeading.id =
      'bm-generation-heading-' +
      Math.random().toString(36).slice(2);

    modal.setAttribute(
      'aria-labelledby',
      modalHeading.id
    );

    const generation = el('select');
    generation.setAttribute(
      'aria-label',
      'Modelgeneration'
    );

    const confirmGeneration = el(
      'button',
      'bm-finder__modal-confirm',
      'Bekræft modelgeneration'
    );

    confirmGeneration.type = 'button';
    confirmGeneration.disabled = true;

    const backGeneration = el(
      'button',
      'bm-finder__modal-back',
      'Tilbage til årgang'
    );

    backGeneration.type = 'button';

    modalPanel.append(
      modalHeading,
      generation,
      confirmGeneration,
      backGeneration
    );

    modal.append(modalPanel);
    document.body.append(modal);

    // Resultat-popup på computer

    const resultsHome = document.createComment(
      'Original position of bulb results'
    );

    results.parentNode.insertBefore(
      resultsHome,
      results
    );

    const resultModal = el(
      'div',
      'bm-bulbs bm-finder__result-modal'
    );

    resultModal.hidden = true;
    resultModal.setAttribute('role', 'dialog');
    resultModal.setAttribute('aria-modal', 'true');
    resultModal.setAttribute(
      'aria-label',
      'Pærer til din bil'
    );

    const resultPanel = el(
      'div',
      'bm-finder__result-panel'
    );

    const resultToolbar = el(
      'div',
      'bm-finder__result-toolbar'
    );

    const resultClose = el(
      'button',
      'bm-finder__result-close',
      'Luk ×'
    );

    resultClose.type = 'button';

    resultToolbar.append(
      el('strong', '', 'Pærer til din bil'),
      resultClose
    );

    resultPanel.append(resultToolbar);
    resultModal.append(resultPanel);
    document.body.append(resultModal);

    const reopen = el(
      'button',
      'bm-finder__reopen',
      'Vis pæreresultater igen'
    );

    reopen.type = 'button';
    reopen.hidden = true;

    resultsHome.parentNode.insertBefore(
      reopen,
      resultsHome
    );

    const desktopResults = window.matchMedia(
      '(min-width: 1024px)'
    );

    let resultsPreviousFocus = null;
    let generationPreviousFocus = null;
    let revision = 0;
    let vehicleId = '';

    const closeResultsModal = () => {
      const wasOpen = !resultModal.hidden;
      resultModal.hidden = true;

      if (
        wasOpen &&
        resultsPreviousFocus?.isConnected
      ) {
        resultsPreviousFocus.focus();
      }

      resultsPreviousFocus = null;
    };

    const positionResults = () => {
      if (desktopResults.matches) {
        if (results.parentNode !== resultPanel) {
          resultPanel.append(results);
        }
        reopen.hidden = results.hidden;
      } else {
        closeResultsModal();

        if (
          results.parentNode !==
          resultsHome.parentNode
        ) {
          resultsHome.parentNode.insertBefore(
            results,
            resultsHome.nextSibling
          );
        }

        reopen.hidden = true;
      }
    };

    const showResults = () => {
      results.hidden = false;
      positionResults();

      if (desktopResults.matches) {
        resultsPreviousFocus = document.activeElement;
        resultModal.hidden = false;
        reopen.hidden = false;
        resultClose.focus();
      }
    };

    const closeGeneration = () => {
      const wasOpen = !modal.hidden;
      modal.hidden = true;

      if (
        wasOpen &&
        generationPreviousFocus?.isConnected
      ) {
        generationPreviousFocus.focus();
      }

      generationPreviousFocus = null;
    };

    const openGeneration = () => {
      generationPreviousFocus = document.activeElement;
      modal.hidden = false;
      confirmGeneration.disabled = !generation.value;
      generation.focus();
    };

    const trapTab = (event, container) => {
      if (event.key !== 'Tab') return;

      const focusable = [
        ...container.querySelectorAll(
          'a[href],button:not([disabled]),select:not([disabled]),input:not([disabled])'
        )
      ].filter(node =>
        node.getClientRects().length &&
        !node.closest('[hidden]')
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    };

    resultClose.addEventListener(
      'click',
      closeResultsModal
    );

    reopen.addEventListener('click', () => {
      if (!results.hidden) showResults();
    });

    resultModal.addEventListener('click', event => {
      if (event.target === resultModal) {
        closeResultsModal();
      }
    });

    resultModal.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        closeResultsModal();
        return;
      }

      trapTab(event, resultPanel);
    });

    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        closeGeneration();
        return;
      }

      trapTab(event, modalPanel);
    });

    if (desktopResults.addEventListener) {
      desktopResults.addEventListener(
        'change',
        positionResults
      );
    } else {
      desktopResults.addListener(positionResults);
    }

    positionResults();

    const clearResults = () => {
      closeResultsModal();
      results.hidden = true;
      reopen.hidden = true;
      results.replaceChildren();
    };

    const clearGeneration = () => {
      vehicleId = '';
      closeGeneration();
      generation.replaceChildren();
      confirmGeneration.disabled = true;
    };

    const refreshSubmit = () => {
      submit.disabled = !(
        brand.value &&
        model.value &&
        year.value &&
        vehicleId
      );
    };

    if (!/^https:\/\//i.test(endpoint)) {
      resetSelect(
        brand,
        'Pæresøgeren er ikke tilsluttet'
      );

      message(
        'Kontrollér API-adressen i temaindstillingerne.'
      );

      refreshSubmit();
      return;
    }

    refreshSubmit();

    // Hent modelgenerationer

    const loadVehicles = async () => {
      const token = ++revision;

      clearGeneration();
      clearResults();
      refreshSubmit();

      if (
        !brand.value ||
        !model.value ||
        !year.value
      ) return;

      message('Kontrollerer modelgeneration…');

      try {
        const data = await load('/vehicles', {
          brand: brand.value,
          model: model.value,
          year: year.value
        });

        if (token !== revision) return;

        const vehicles = Array.isArray(data.vehicles)
          ? data.vehicles
          : [];

        if (!vehicles.length) {
          message(
            'Ingen registreringer fundet for årgangen. Kontakt kundeservice for hjælp.'
          );

          addSupport(
            {},
            'Vi mangler oplysninger for denne bil og årgang.'
          );

          showResults();
          return;
        }

        if (vehicles.length === 1) {
          vehicleId = String(vehicles[0].id);

          message(
            'Klar til at finde vejledende pæretyper.'
          );
        } else {
          generation.add(
            new Option('Vælg modelgeneration', '')
          );

          for (const v of vehicles) {
            const label = String(
              v.label ||
              `${v.model} (${v.year_start}–${v.year_end ?? 'åben'})`
            );

            generation.add(
              new Option(label, String(v.id))
            );
          }

          openGeneration();

          message(
            'Flere registreringer matcher. Vælg modelgeneration i popup-vinduet.'
          );
        }

        refreshSubmit();
      } catch {
        if (token === revision) {
          message(
            'Kunne ikke hente modelgenerationer. Prøv igen.'
          );
        }
      }
    };

    // Bilmærke

    brand.addEventListener('change', async () => {
      const token = ++revision;

      resetSelect(model, 'Vælg først bilmærke');
      resetSelect(year, 'Vælg først model');

      clearGeneration();
      clearResults();
      refreshSubmit();

      if (!brand.value) {
        message('Vælg bilmærke.');
        return;
      }

      message('Henter modeller…');

      try {
        const data = await load('/models', {
          brand: brand.value
        });

        if (token !== revision) return;

        populate(
          model,
          Array.isArray(data.models)
            ? data.models
            : [],
          'Vælg model'
        );

        message(
          model.disabled
            ? 'Ingen modeller fundet.'
            : 'Vælg model.'
        );
      } catch {
        if (token === revision) {
          message(
            'Kunne ikke hente modeller. Prøv igen.'
          );
        }
      }
    });

    // Bilmodel

    model.addEventListener('change', async () => {
      const token = ++revision;

      resetSelect(year, 'Vælg først model');

      clearGeneration();
      clearResults();
      refreshSubmit();

      if (!model.value) {
        message('Vælg model.');
        return;
      }

      message('Henter årgange…');

      try {
        const data = await load('/years', {
          brand: brand.value,
          model: model.value
        });

        if (token !== revision) return;

        populate(
          year,
          Array.isArray(data.years)
            ? data.years
            : [],
          'Vælg årgang'
        );

        message(
          year.disabled
            ? 'Ingen årgange fundet.'
            : 'Vælg årgang.'
        );
      } catch {
        if (token === revision) {
          message(
            'Kunne ikke hente årgange. Prøv igen.'
          );
        }
      }
    });

    year.addEventListener(
      'change',
      loadVehicles
    );

    generation.addEventListener('change', () => {
      confirmGeneration.disabled =
        !generation.value;
    });

    confirmGeneration.addEventListener(
      'click',
      () => {
        if (!generation.value) {
          generation.focus();
          return;
        }

        ++revision;
        vehicleId = generation.value;

        closeGeneration();
        clearResults();
        refreshSubmit();

        message(
          'Klar til at finde vejledende pæretyper.'
        );
      }
    );

    backGeneration.addEventListener(
      'click',
      () => {
        ++revision;
        clearGeneration();
        year.value = '';

        clearResults();
        refreshSubmit();

        message('Vælg en årgang.');
        year.focus();
      }
    );

    // Danske navne til alle positioner i Worker v3

    const positionLabels = {
      dipped_beam: 'Nærlys',
      main_beam: 'Fjernlys',
      hid_headlight: 'Xenon / HID-forlygte',
      front_fog: 'Tågelys foran',

      rear_tail: 'Baglys',
      reverse_light: 'Baklys',
      rear_indicator: 'Blinklys bag',
      front_indicator: 'Blinklys foran',
      brake_light: 'Bremselys',
      license_plate: 'Nummerpladelys',
      front_position: 'Positionslys foran',
      side_indicator: 'Sideblinklys',
      rear_fog: 'Tågebaglys',

      // Kompatibilitet med tidligere API-navne
      side_light: 'Positionslys',
      indicator_front: 'Blinklys foran',
      indicator_rear: 'Blinklys bag',
      tail_light: 'Baglys',
      reversing_light: 'Baklys',
      number_plate: 'Nummerpladelys'
    };

    // Søg efter pærer

    form.addEventListener('submit', async event => {
      event.preventDefault();

      if (submit.disabled) return;

      const token = ++revision;

      const selected = {
        brand: brand.value,
        model: model.value,
        year: year.value,
        vehicle_id: vehicleId
      };

      submit.disabled = true;
      clearResults();

      message('Finder pærer…');

      try {
        const data = await load(
          '/fitment',
          selected
        );

        if (token !== revision) return;

        if (data.requires_vehicle_selection) {
          await loadVehicles();
          return;
        }

        const items = Array.isArray(data.fitments)
          ? data.fitments
          : [];

        const missing =
          Number(data.missing_fitments) || 0;

        const missingPositions =
          Array.isArray(data.missing_positions)
            ? data.missing_positions
            : [];

        const header = el(
          'div',
          'bm-finder__results-head'
        );

        const count = el(
          'span',
          'bm-finder__count',
          `${items.length} registreringer`
        );

        header.append(
          el(
            'h3',
            '',
            'Mulige pærer til din bil'
          ),
          count
        );

        results.append(header);

        results.append(
          el(
            'p',
            'bm-finder__vehicle',
            `${selected.brand} · ${selected.model} · ${selected.year}`
          )
        );

        if (data.vehicle?.label) {
          results.append(
            el(
              'p',
              'bm-finder__muted',
              String(data.vehicle.label)
            )
          );
        }

        if (data.year_range_provisional) {
          results.append(
            el(
              'p',
              'bm-finder__variant-alert',
              'Årgangsintervallet er åbent i kildekataloget. Kontrollér bilens konkrete generation.'
            )
          );
        }

        addNotice(
          'Vigtigt: Kontrollér din originale pære',
          data.compatibility_warning ||
          'Pæretyperne er vejledende katalogdata, ikke bekræftet kompatibilitet. Kontrollér den originale pære før køb.'
        );

        // Gruppér pærer efter placering

        const groups = new Map();

        for (const item of items) {
          const position = String(
            item.position || 'other'
          ).trim();

          const type = String(
            item.bulb_type || ''
          ).trim().toUpperCase();

          if (!type) continue;

          if (!groups.has(position)) {
            groups.set(position, new Map());
          }

          if (!groups.get(position).has(type)) {
            groups.get(position).set(type, item);
          }
        }

        const hasHeadlightChoice =
          groups.has('dipped_beam') &&
          groups.has('hid_headlight');

        let headlightChoice = null;

        if (hasHeadlightChoice) {
          const choiceBox = addNotice(
            'Vælg bilens forlygtetype',
            'Kataloget indeholder både almindeligt nærlys og xenon/HID. Vælg den type bilen har. Er du i tvivl, skal den originale pære kontrolleres.'
          );

          headlightChoice = el(
            'select',
            'bm-finder__headlight-choice'
          );

          headlightChoice.setAttribute(
            'aria-label',
            'Bilens forlygtetype'
          );

          headlightChoice.add(
            new Option(
              'Vælg forlygtetype',
              ''
            )
          );

          headlightChoice.add(
            new Option(
              'Halogen / almindelig forlygte (H7)',
              'halogen'
            )
          );

          headlightChoice.add(
            new Option(
              'Xenon / HID (D2S)',
              'xenon'
            )
          );

          choiceBox.append(headlightChoice);
        }

        // Opret resultatkort

        const grid = el(
          'div',
          'bm-finder__compact-grid'
        );

        const allCards = [];

        
        // Shopify-produkter fra filtreret kollektion
        const shopProductCache = new Map();

        const getShopProducts = async (bulbType) => {
          const type = String(bulbType || '').trim().toUpperCase();

          if (!/^[A-Z0-9-]{1,20}$/.test(type)) return [];

          if (!shopProductCache.has(type)) {
           const url = new URL(
  'https://bilmedie.dk/collections/bilpaerer',
  window.location.origin
);

            url.searchParams.set('view', 'bulb-products-json');
            url.searchParams.set(
              'filter.p.m.custom.fatning',
              type
            );

            const request = fetch(url.toString(), {
  headers: { Accept: 'text/html' }
})
              .then(async response => {
                if (!response.ok) {
                  throw new Error('Shopify HTTP ' + response.status);
                }

                const data = await response.json();

                console.log(
  'Bilmedie produkt-JSON:',
  JSON.stringify(data).slice(0, 1000)
);

       if (!Array.isArray(data.products)) {
  throw new Error(
    'Shopify svarer: ' +
    JSON.stringify(data).slice(0, 400)
  );
}

                return data.products.filter(product =>
                  Array.isArray(product.fatninger) &&
                  product.fatninger.some(
                    fatning =>
                      String(fatning).trim().toUpperCase() === type
                  )
                );
              })
              .catch(error => {
                shopProductCache.delete(type);
                throw error;
              });

            shopProductCache.set(type, request);
          }

          return shopProductCache.get(type);
        };

      
const classifyShopProduct = product => {
  const title = String(product.title || '');

  // LED-konverteringer og LED-pærer
  if (/\bLED\b/i.test(title)) return 'led';

  // Xenon / HID
  if (/\bXENON\b|\bHID\b/i.test(title)) return 'xenon';

  // Almindelige glødepærer og halogenpærer
  // Omfatter også P21W, P21/5W, W5W, H4 osv.
  return 'halogen';
};


        const renderShopProduct = product => {
          const variant = (product.variants || []).find(
            item => item.available
          ) || (product.variants || [])[0];

          if (!variant) return null;

          const card = el('a', 'bm-shop-product');

          const url = new URL(
            '/products/' + encodeURIComponent(product.handle),
            window.location.origin
          );

          url.searchParams.set('variant', String(variant.id));
          card.href = url.pathname + url.search;

          const image = el('img', 'bm-shop-product__image');
          if (product.image) {
            image.src = product.image;
            image.alt = String(product.title || '');
            image.loading = 'lazy';
          }

          const content = el('div', 'bm-shop-product__content');

          const title = el(
            'span',
            'bm-shop-product__title',
            product.title
          );

          const price = el(
            'strong',
            'bm-shop-product__price',
            (Number(variant.price) / 100).toLocaleString(
              'da-DK',
              {
                style: 'currency',
                currency: 'DKK'
              }
            )
          );

          const availability = el(
            'span',
            'bm-shop-product__availability',
            variant.available ? 'På lager' : 'Ikke på lager'
          );

          content.append(title, price, availability);
          card.append(image, content);

          return card;
        };


        for (const [position, types] of groups) {
          const card = el(
            'div',
            'bm-finder__compact-card'
          );

          card.dataset.bulbPosition = position;

          card.append(
            el(
              'div',
              'bm-finder__compact-position',
              positionLabels[position] || position
            )
          );

          const chips = el(
            'div',
            'bm-finder__chips'
          );

          for (const [type, item] of types) {
            const chip = el(
              'a',
              'bm-finder__chip',
              type
            );

            chip.href = safeShopUrl(
              item.collection_url,
              '/collections/bilpaerer?filter.p.m.custom.fatning=' +
                encodeURIComponent(type)
            );

            chip.title =
              'Se pærer med fatningen ' +
              type +
              '. Kontrollér kompatibilitet før køb.';

            chips.append(chip);
          }

          card.append(chips);

          
            // Vis Shopify-produkter under pæretypen
            const productArea = el(
              'div',
              'bm-shop-products'
            );

            const productStatus = el(
              'p',
              'bm-shop-products__status',
              'Henter produkter…'
            );

            const productList = el(
              'div',
              'bm-shop-products__list'
            );

            productArea.append(productStatus, productList);
            card.append(productArea);

            const loadCardProducts = async () => {
              productList.replaceChildren();

              const bulbTypes = [...types.keys()];

              productStatus.textContent = 'Henter produkter…';

              try {
                const responses = await Promise.all(
                  bulbTypes.map(getShopProducts)
                );

                if (token !== revision) return;

                const unique = new Map();

                for (const products of responses) {
                  for (const product of products) {
                    unique.set(product.id, product);
                  }
                }

                const products = [...unique.values()];

                const expectedTechnology =
                  position === 'hid_headlight'
                    ? 'xenon'
                    : 'halogen';

                const standard = products.filter(product => {
                  const technology = classifyShopProduct(product);
                  const title = String(product.title || '');

                  // Udeluk 24V-only produkter
                  if (
                    /\b24\s*V\b/i.test(title) &&
                    !/\b12\s*[-/]\s*24\s*V\b/i.test(title)
                  ) {
                    return false;
                  }

                  // Udeluk ikke-standard 80W halogen
                  if (
                    technology === 'halogen' &&
                    /\b80\s*W\b/i.test(title)
                  ) {
                    return false;
                  }

                  return technology === expectedTechnology;
                });

                const alternatives = products.filter(
                  product =>
                    classifyShopProduct(product) === 'led' &&
                    !(
                      /\b24\s*V\b/i.test(product.title) &&
                      !/\b12\s*[-/]\s*24\s*V\b/i.test(product.title)
                    )
                );

                const visible = standard.slice(0, 3);

                productStatus.textContent = visible.length
                  ? 'Udvalgte almindelige pærer'
                  : 'Ingen almindelige pærer fundet';

                for (const product of visible) {
                  const productCard = renderShopProduct(product);

                  if (productCard) productList.append(productCard);
                }

                if (alternatives.length) {
                  const alternativeLabel = el(
                    'p',
                    'bm-shop-products__alternative-label',
                    'LED-opgraderinger – kontrollér lovlighed og kompatibilitet'
                  );

                  productList.append(alternativeLabel);

                  for (const product of alternatives.slice(0, 2)) {
                    const productCard = renderShopProduct(product);

                    if (productCard) productList.append(productCard);
                  }
                }
              }  catch (error) {
  if (token !== revision) return;

  console.error('Bilmedie Shopify-produktfejl:', error);

  productStatus.textContent =
    'Produktfejl: ' + error.message;
}
            };

            card.loadShopProducts = loadCardProducts;


          if (types.size > 1) {
            card.append(
              el(
                'small',
                'bm-finder__variant-alert',
                'Alternative pæretyper – kontrollér lygtevarianten.'
              )
            );
          }

          grid.append(card);
          allCards.push(card);
        }

        if (grid.children.length) {
          results.append(grid);
        }

        if (
          missing > 0 ||
          data.contact_support ||
          !items.length
        ) {
          const details = missingPositions.length
            ? ' Manglende oplysninger: ' +
              missingPositions
                .map(p => positionLabels[p] || p)
                .join(', ') +
              '.'
            : '';

          addSupport(
            data,
            (
              data.support_message ||
              'Kontrollér bilens originale pære.'
            ) + details
          );
        }

     

        let choiceRevision = 0;

        // Opdater synlige pærer efter valg af forlygte

       
const updateHeadlights = () => {
  const currentChoice = headlightChoice?.value || '';

  let visibleRegistrations = 0;

  for (const card of allCards) {
    const position = card.dataset.bulbPosition;

    const hidden = hasHeadlightChoice && (
      (position === 'dipped_beam' && currentChoice !== 'halogen') ||
      (position === 'hid_headlight' && currentChoice !== 'xenon')
    );

    card.hidden = hidden;

    if (hidden) continue;

    if (!card.dataset.productsLoaded) {
      card.dataset.productsLoaded = '1';
      card.loadShopProducts?.();
    }

    const positionTypes = groups.get(position);
    visibleRegistrations += positionTypes.size;
  }

  count.textContent = `${visibleRegistrations} registreringer`;
};


        if (headlightChoice) {
          headlightChoice.addEventListener(
            'change',
            updateHeadlights
          );
        }

        showResults();

        message(
          items.length
            ? 'Vejledende katalogdata – kontrollér bilens lygtevariant.'
            : 'Vi kan ikke fastslå pæretypen. Kontakt kundeservice.'
        );

        await updateHeadlights();

      } catch (error) {
        if (token === revision) {
          clearResults();

          message(
            'Kunne ikke hente pæretyper. Prøv igen senere.'
          );
        }
      } finally {
        if (token === revision) {
          refreshSubmit();
        }
      }
    });

    // Start søgeren

    message('Henter bilmærker…');

    load('/brands')
      .then(data => {
        populate(
          brand,
          Array.isArray(data.brands)
            ? data.brands
            : [],
          'Vælg bilmærke'
        );

        message(
          brand.disabled
            ? 'Ingen bilmærker tilgængelige.'
            : 'Vælg bilmærke for at begynde.'
        );
      })
      .catch(() => {
        message(
          'Kunne ikke hente bilmærker. Kontrollér API-adressen og CORS.'
        );
      });
  };

  const init = () => {
    document
      .querySelectorAll('[data-bm-bulb-finder]')
      .forEach(initFinder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();
